import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { queryStringUpdater } from '../queryStringUpdater';
import { createContext } from './createContext';
import { messageEventManager } from '../messageEventManager';

export function runApp() {
  const context = createContext();
  const store = createApplicationState(context);

  store.subscribe(() => queryStringUpdater(store.getState()));
  messageEventManager.init(store);

  renderApplication({ store, context });
}
